import React from 'react'

const Empty = () => (
    <h2 style={{ minHeight: '85vh', textAlign: 'center', marginTop: '20px' }}>
        Nothing here!
    </h2>
)

export default Empty
